<script lang="ts">
    import { VpEditIcon } from '@decathlon-experience/icons/svelte';
    import { createDialog } from '@melt-ui/svelte';
    import { fade } from 'svelte/transition';

    import { trans } from '$assets/shop-translator.js';
    import Button from '$saga/components/Button.svelte';
    import { flyDrawer } from '$saga/utils/customTransitions';
    import AccommodationEditRoomPax from '$saga/views/Funnel/AccommodationEditRoomPax.svelte';
    import { isModalOpen } from '$saga/views/Tour/store';

    export let tourType: number;
    export let tourCode: string;
    export let bookingType: string;
    export let isTravelAloneAuthorized: boolean;
    export let minAgeAllowed: number;
    export let maxAgeAllowed: number;
    export let childrenAgesConfig: { [key: string]: string };
    export let datesInfos: {
        occupancies?: Array<{
            adults: number;
            children: number;
            childrenAges: string[];
        }> | null;
        totalAdults: number;
        totalChildren: number;
        totalRooms: number;
        startDate: string;
        endDate: string;
        adultAges?: number[];
        remainingStock?: number | null;
    };
    export let bookingFormAction: string;

    // Melt UI Dialog
    const {
        elements: { trigger, overlay, content, portalled },
        states: { open },
    } = createDialog({
        open: isModalOpen,
        forceVisible: true,
    });
</script>

<button
    class="text-content-brand underline hover:no-underline w-fit whitespace-nowrap flex items-center"
    {...$trigger}
    use:trigger
>
    <span class="pr-2xs"><VpEditIcon class="size-m" /></span>
    <span class="text-sm pr-2xs">
        {trans('tour.aside_panel.travelgate.adults_count', {
            '%count%': String(
                datesInfos.totalAdults + datesInfos.totalChildren,
            ),
        })}
    </span>
    <span class="text-sm">
        {trans('tour.aside_panel.travelgate.room_count', {
            '%count%': String(datesInfos.totalRooms),
        })}
    </span>
</button>

{#if $open}
    <section {...$portalled} use:portalled>
        <div
            {...$overlay}
            use:overlay
            class="fixed inset-0 z-40 bg-black/50"
            transition:fade={{ duration: 250 }}
        ></div>
        <section
            {...$content}
            use:content
            class="fixed inset-x-0 bottom-0 z-50 flex h-full max-h-[calc(100%)] w-full flex-col bg-white transition-all duration-500 desktop:inset-x-[unset] desktop:right-0 desktop:top-0 desktop:min-w-[33vw] desktop:max-w-[33vw]"
            transition:flyDrawer
        >
            <section class="flex h-full flex-col overflow-hidden">
                <!-- Header -->
                <div
                    class="sticky top-0 z-50 mx-m flex min-h-[65px] items-center justify-center border-b border-solid border-border-quiet bg-white py-m desktop:mx-3xl"
                >
                    {trans('funnel.accommodation.travelgate.drawer_title')}
                </div>
                <div
                    class="no-scrollbar flex flex-1 flex-col overflow-y-auto px-l desktop:px-3xl"
                >
                    <form
                        action={bookingFormAction}
                        method="POST"
                        id="accommodation-edit-room-pax-form"
                        class="mb-xl"
                    >
                        <input
                            class="hidden"
                            name="startDate"
                            value={datesInfos.startDate}
                        />
                        <input
                            class="hidden"
                            name="code"
                            bind:value={tourCode}
                        />

                        <AccommodationEditRoomPax
                            {tourType}
                            {bookingType}
                            {isTravelAloneAuthorized}
                            {minAgeAllowed}
                            {maxAgeAllowed}
                            {childrenAgesConfig}
                            {datesInfos}
                        />
                    </form>
                    <!-- Footer -->
                    <div
                        class="sticky bottom-0 left-0 flex w-full justify-between border-t border-solid border-border-quiet bg-white py-s mt-auto"
                    >
                        <Button
                            class="mb-xl w-full"
                            type="submit"
                            form="accommodation-edit-room-pax-form"
                        >
                            {trans('tour.aside_panel.travelgate.validate')}
                        </Button>
                    </div>
                </div>
            </section>
        </section>
    </section>
{/if}
